<div
    class="sidebar-area bg-white active"
    [ngClass]="{ active: isSidebarToggled }"
    [class.component-dark-theme]="themeService.isDark()"
    [class.dark-sidebar]="themeService.isSidebarDark()"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <ng-container *transloco="let t">
        <div class="logo bg-white">
            <a routerLink="/dashboard" class="d-flex align-items-center">
                <ng-container *ngIf="!themeService.isDark()">
                    <img
                        src="assets/images/icono-intrust-security-ciberseguridad-claro.png"
                        alt="logo-icon"
                        width="25%"
                        height="25%"
                    />
                </ng-container>
                <ng-container *ngIf="themeService.isDark()">
                    <img
                        src="assets/images/icono-intrust-security-ciberseguridad-oscuro.png"
                        alt="logo-icon"
                        width="25%"
                        height="25%"
                    />
                </ng-container>
                <span class="fw-semibold">Altair</span>
            </a>
        </div>
        <div
            (click)="toggle()"
            class="burger-menu"
            [ngClass]="{ active: isSidebarToggled }"
        >
            <span class="top-bar"></span>
            <span class="middle-bar"></span>
            <span class="bottom-bar"></span>
        </div>
        <ng-scrollbar visibility="hover">
            <div class="sidebar-inner">
                <div class="sidebar-menu">
                    <mat-accordion>
                        @if (user) {
                        <ng-container *ngFor="let menu of user.menu">
                            <ng-container *ngIf="menu.label">
                                <mat-expansion-panel
                                    (opened)="panelOpenState = true"
                                    (closed)="panelOpenState = true"
                                >
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <i
                                                class="material-symbols-outlined"
                                            >
                                                star_border
                                            </i>
                                            <span class="title">
                                                {{ t(menu.label) }}
                                            </span>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <ul class="sidebar-sub-menu">
                                        <ng-container
                                            *ngFor="let item of menu.items"
                                        >
                                            <li class="sidemenu-item">
                                                <ng-container
                                                    *ngIf="item.routerLink"
                                                >
                                                    <a
                                                        routerLink="{{
                                                            item.routerLink[0]
                                                        }}"
                                                        routerLinkActive="active"
                                                        [routerLinkActiveOptions]="{
                                                            exact: true
                                                        }"
                                                        class="sidemenu-link"
                                                    >
                                                        <i
                                                            class="material-symbols-outlined"
                                                        >
                                                            {{ item.icon }}
                                                        </i>
                                                        <span class="title">
                                                            {{ t(item.label) }}
                                                        </span>
                                                    </a>
                                                </ng-container>
                                                <ng-container
                                                    *ngIf="item.items"
                                                >
                                                    <mat-expansion-panel
                                                        (opened)="
                                                            panelOpenState = true
                                                        "
                                                        (closed)="
                                                            panelOpenState = true
                                                        "
                                                    >
                                                        <mat-expansion-panel-header>
                                                            <mat-panel-title>
                                                                {{
                                                                    t(
                                                                        item.label
                                                                    )
                                                                }}
                                                            </mat-panel-title>
                                                        </mat-expansion-panel-header>
                                                        <ul
                                                            class="sidebar-sub-menu"
                                                        >
                                                            <ng-container
                                                                *ngFor="
                                                                    let subItem of item.items
                                                                "
                                                            >
                                                                <li
                                                                    class="sidemenu-item"
                                                                >
                                                                    <ng-container
                                                                        *ngIf="
                                                                            subItem.routerLink
                                                                        "
                                                                    >
                                                                        <a
                                                                            href="{{
                                                                                subItem
                                                                                    .routerLink[0]
                                                                            }}"
                                                                            routerLinkActive="active"
                                                                            [routerLinkActiveOptions]="{
                                                                                exact: true
                                                                            }"
                                                                            class="sidemenu-link"
                                                                        >
                                                                            {{
                                                                                t(
                                                                                    subItem.label
                                                                                )
                                                                            }}
                                                                        </a>
                                                                    </ng-container>
                                                                </li>
                                                            </ng-container>
                                                        </ul>
                                                    </mat-expansion-panel>
                                                </ng-container>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </mat-expansion-panel>
                            </ng-container>
                            <ng-container *ngIf="!menu.label">
                                <ng-container *ngFor="let item of menu.items">
                                    <ng-container *ngIf="item.routerLink">
                                        <a
                                            routerLink="{{
                                                item.routerLink[0]
                                            }}"
                                            class="sidebar-menu-link"
                                            routerLinkActive="active"
                                            [routerLinkActiveOptions]="{
                                                exact: true
                                            }"
                                        >
                                            <i
                                                class="material-symbols-outlined"
                                            >
                                                {{ item.icon }}
                                            </i>
                                            <span class="title">
                                                {{ item.label }}
                                            </span>
                                        </a>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                        @if (user.role == internal) {
                        <mat-expansion-panel
                            (opened)="panelOpenState = true"
                            (closed)="panelOpenState = true"
                        >
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <i class="material-symbols-outlined">
                                        arrows_output
                                    </i>
                                    <span class="title">{{t('ASM')}}</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <ul class="sidebar-sub-menu">
                                <li class="sidemenu-item" *ngIf="false">
                                    <a
                                        routerLink="/asmview/dashboard"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        class="sidemenu-link"
                                    >
                                        <i class="material-symbols-outlined">
                                            home
                                        </i>
                                        <span class="title"> Dashboard </span>
                                    </a>
                                </li>
                                <li class="sidemenu-item">
                                    <a
                                        routerLink="/asmview/targets"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        class="sidemenu-link"
                                    >
                                        <i class="material-symbols-outlined">
                                            location_searching
                                        </i>
                                        <span class="title">
                                            {{ t("targets") }}
                                        </span>
                                    </a>
                                </li>
                                <li class="sidemenu-item">
                                    <a
                                        routerLink="/asmview/quick-scan-history"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        class="sidemenu-link"
                                    >
                                        <i class="material-symbols-outlined">
                                            radar
                                        </i>
                                        <span class="title">
                                            {{ t("scan-history") }}
                                        </span>
                                    </a>
                                </li>
                                <li class="sidemenu-item">
                                    <a
                                        routerLink="/asmview/vulnerabilities"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        class="sidemenu-link"
                                    >
                                        <i class="material-symbols-outlined">
                                            warning
                                        </i>
                                        <span class="title">
                                            {{ t("vulnerabilities") }}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </mat-expansion-panel>
                        }
                        <mat-expansion-panel
                            (opened)="panelOpenState = true"
                            (closed)="panelOpenState = true"
                        >
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <i class="material-symbols-outlined">
                                        arrows_input
                                    </i>
                                    <span class="title">{{t('internal-surface')}}</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <ul class="sidebar-sub-menu">
                                <li class="sidemenu-item">
                                    <a
                                        routerLink="/internal-surface/infrastructure"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        class="sidemenu-link"
                                    >
                                        <i class="material-symbols-outlined">
                                            network_node
                                        </i>
                                        <span class="title">
                                            {{ t("infrastructure") }}
                                        </span>
                                    </a>
                                </li>
                                <li class="sidemenu-item">
                                    <a
                                        routerLink="/internal-surface/active-directory"
                                        routerLinkActive="active"
                                        [routerLinkActiveOptions]="{
                                            exact: true
                                        }"
                                        class="sidemenu-link"
                                    >
                                        <i class="material-symbols-outlined">
                                            home_storage
                                        </i>
                                        <span class="title">
                                            {{ t("active-directory") }}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </mat-expansion-panel>
                        <a
                            routerLink="/reports"
                            class="sidebar-menu-link"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                        >
                            <i class="material-symbols-outlined"> table_chart_view </i>
                            <span class="title">
                                {{ t("reports") }}
                            </span>
                        </a>
                        <a
                            routerLink="/logout"
                            class="sidebar-menu-link"
                            routerLinkActive="active"
                            [routerLinkActiveOptions]="{ exact: true }"
                        >
                            <i class="material-symbols-outlined"> logout </i>
                            <span class="title">
                                {{ t("logout") }}
                            </span>
                        </a>
                        }
                    </mat-accordion>
                </div>
            </div>
        </ng-scrollbar>
    </ng-container>
</div>
